export const NAME = 'analytics' as const;

export const STATSIG_LOGGING_BUFFER_MAX_SIZE = 2;
export const STATSIG_LOGGING_INTERVAL_MS = 1000;


